import { ArrowRight } from "lucide-react";

export const Pricing = () => (
  <section
    id="priser"
    aria-labelledby="pricing-heading"
    className="bg-[var(--paper)] pb-10 md:pb-12"
  >
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <div className="grid items-center gap-6 rounded-3xl border border-[var(--line)] bg-white p-6 sm:p-8 lg:grid-cols-12 lg:gap-10 lg:p-10">
        <div className="lg:col-span-6">
          <p className="eyebrow">Pris & offert</p>
          <h2
            id="pricing-heading"
            className="mt-3 text-2xl font-bold tracking-tight sm:text-3xl"
          >
            Tydliga priser, utan krångel
          </h2>
          <p className="mt-3 max-w-lg leading-relaxed text-[var(--ink-soft)]">
            För privatpersoner visar vi timpriset direkt. För företag,
            BRF:er och fastighetsägare går Mats igenom uppdraget och
            tar fram en offert som passar.
          </p>
          <a
            href="#offert"
            className="mt-5 inline-flex items-center gap-2 font-semibold text-[var(--red)] underline-offset-4 hover:underline"
          >
            Begär en offert
            <ArrowRight size={18} aria-hidden />
          </a>
        </div>

        <div className="rounded-2xl bg-[var(--paper)] px-5 py-5 sm:px-6 sm:py-6 lg:col-span-6">
          <p className="text-xs font-semibold uppercase tracking-[0.08em] text-[var(--ink-soft)]">
            Timpris för privatpersoner
          </p>
          <div className="mt-2 flex flex-wrap items-baseline gap-x-2 gap-y-1">
            <strong className="font-display text-4xl font-bold tracking-tight text-[var(--ink)] sm:text-5xl">
              490 kr
            </strong>
            <span className="text-sm text-[var(--ink-soft)]">/tim inkl. moms</span>
          </div>
          <div className="mt-4 flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 border-t border-[var(--line)] pt-4">
            <span className="font-medium text-[var(--ink-soft)]">Efter RUT-avdrag*</span>
            <strong className="font-display text-2xl font-bold text-[var(--red)]">
              245 kr/tim
            </strong>
          </div>
          <p className="mt-3 text-xs leading-relaxed text-[var(--ink-soft)]">
            * RUT gäller avdragsberättigad arbetskostnad och förutsätter
            att du har rätt till avdraget.
          </p>
        </div>
      </div>
    </div>
  </section>
);
